import React from "react";

export default function GradientMesh({ className = "" }) {
  return <div aria-hidden="true" className={"mesh-bg " + className} />;
}
